export const getStyle = (type, value) => {
  const styleData = value?.style?.[type] || {};

  switch (type) {
    case 'MouseFollowerType1':
      return {
        background: styleData.background || '',
        size:styleData.size,
      };
    case 'MouseFollowerType2':
      return {
        background: styleData.background || '',
        size:styleData.size,
      };
    case 'MouseFollowerType3':
      return {
        background: styleData.background || '',
      };
    case 'MouseFollowerType4':
      return {
        background: styleData.background || '',
      };
    case 'MouseFollowerType5':
      return {
        background: styleData.background || '',
      };
    default:
      return {};
  }
};
